interface CustomerQuestionInput {
  name?: string | null;
  company?: string | null;
  phone?: string | null;
  email?: string | null;
  contactId?: number | string | null;
}

interface FollowUpQuestionInput extends CustomerQuestionInput {
  description: string;
  type?: string | null;
  source?: string | null;
  due?: string | null;
}

function clean(value?: string | number | null): string {
  return String(value ?? '').trim();
}

function customerSubject(input: CustomerQuestionInput): string {
  const name = clean(input.name);
  const company = clean(input.company);
  const phone = clean(input.phone);
  const email = clean(input.email);
  const contactId = clean(input.contactId);

  if (name && company && name !== company) return `${name} at ${company}`;
  if (name) return name;
  if (company) return company;
  if (phone) return phone;
  if (email) return email;
  if (contactId) return `contact ${contactId}`;
  return 'this customer';
}

export function qaHref(question: string): string {
  return `/qa?q=${encodeURIComponent(question)}`;
}

export function customerEvidenceQuestion(input: CustomerQuestionInput): string {
  const subject = customerSubject(input);
  return `What evidence do we have for ${subject}? Summarize the latest customer ask, open follow-ups, promises, and handoff risks.`;
}

export function followUpEvidenceQuestion(input: FollowUpQuestionInput): string {
  const subject = customerSubject(input);
  const type = clean(input.type);
  const source = clean(input.source);
  const due = clean(input.due);
  const context = [
    type ? `type: ${type}` : '',
    source ? `source: ${source}` : '',
    due ? `due: ${due}` : '',
  ].filter(Boolean).join('; ');
  const suffix = context ? ` Include ${context}.` : '';

  return `What evidence supports this follow-up for ${subject}: "${input.description}"? Summarize the source, current owner, blockers, and safest next step.${suffix}`;
}

export const QT_DAILY_COCKPIT_URL = 'https://tracker.overlanddesignbuild.com';
